
 const button = document.getElementById('togglebutton');
  const content = document.getElementById('mycontent');

  button.onclick = function() {
    if (content.style.display === 'none') {
      content.style.display = 'inline';
      button.textContent = 'Read Less';
    } else {
      content.style.display = 'none';
      button.textContent = 'Read More';
    }
  };